import { CloudUpload } from 'lucide-react';
import moment from 'moment';

import { findNumberOfFiles, formatDateWithoutSeconds } from '@/utils';
import type { LinkQueryResult } from '../../traceInspector.types';

type Props = {
  link: LinkQueryResult;
};

export const WhoDidWhatWhen = ({ link }: Props) => {
  const renderNbDocuments = () => {
    if (!link?.data) return null;

    const fileLength = findNumberOfFiles(link.data);

    if (fileLength === 0) return null;

    return (
      <span
        className="flex select-none items-center gap-2 rounded-full border border-border bg-accent px-3 py-1 font-bold text-accent-foreground"
        data-cy="number-of-files"
      >
        <CloudUpload size={14} />
        {fileLength === 1 ? '1 file' : `${fileLength} files`}
      </span>
    );
  };

  const createdAt = moment.utc(link.createdAt).local();

  const whatGroup = link?.group?.name;

  return (
    <div className="flex items-center gap-2.5 text-muted-foreground text-xs">
      <p>
        Submitted{' '}
        {whatGroup && (
          <>
            by <span className="font-semibold">{whatGroup}</span>,
          </>
        )}{' '}
        on {formatDateWithoutSeconds(createdAt)}
      </p>
      {renderNbDocuments()}
    </div>
  );
};

WhoDidWhatWhen.displayName = 'WhoDidWhatWhen';
